<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head :searchConfig="tableData.searchConfig" @searchData="searchData" />
    </template>
    <template>
      <Body :headConfig="tableData.headConfig" :tableData="data.list" />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
  </Layout>
</template>

<script>
import getFailPosting from "@/api/getFailPosting.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";
export default {
  mixins: [requstData({ list: [], total: 0 }, true)],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "id",
          list: [
            { label: "专页名称", prop: "pageName", width: "200" },
            { label: "错误信息", prop: "note", tip: true },
            { label: "接口类型", prop: "postType", width: "100" },
            { label: "用户名", prop: "userName", width: "250" },
            { label: "创建日期", prop: "createTime", width: "200" },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "input",
              model: "userName",
              span: 4,
              placeholder: "请输入用户名",
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "查询",
                  style: "primary",
                  listeners: "searchData",
                },
              ],
            },
          ],
        },
      },
    };
  },
  methods: {
    async requst(params) {
      let res = await getFailPosting(params);
      res.list.map((item, index) => {
        item.id = index;
      });
      return res;
    },
  },
};
</script>

<style></style>
